import React, { useEffect } from 'react';
import './../styles/service-page.css';
import GutterImg from "./../../public/images/gutter.jpg";

const GutterCleaningPage = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);

    // Parallax effect for hero background
    // const handleScroll = () => {
    //   const scrolled = window.scrollY;
    //   const heroBackground = document.querySelector('.hero-section');
    //   if (heroBackground && scrolled < 600) {
    //     const yPos = -(scrolled * 0.5);
    //     heroBackground.style.backgroundPositionY = `${yPos}px`;
    //   }
    // };

    // window.addEventListener('scroll', handleScroll);

    // Add scroll animations matching homepage
    const observeElements = () => {
      const elements = document.querySelectorAll('.slide-in-up, .slide-in-left, .slide-in-right');
      
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      });

      elements.forEach(element => {
        observer.observe(element);
      });

      // Stagger animations for service cards
      const cards = document.querySelectorAll('.service-card');
      cards.forEach((card, index) => {
        card.style.transitionDelay = `${index * 0.1}s`;
      });

      // Stagger process steps
      const steps = document.querySelectorAll('.process-step');
      steps.forEach((step, index) => {
        step.style.transitionDelay = `${index * 0.15}s`;
      });
    };

    setTimeout(observeElements, 100);

    // Cleanup
    // return () => {
    //   window.removeEventListener('scroll', handleScroll);
    // };
  }, []);

  return (
    <div className="service-page">
      {/* Hero Section with Background Image */}
      <section 
        className="hero-section"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),url('https://media.istockphoto.com/id/1356621962/photo/cleaning-the-gutter-from-autumn-leaves-before-winter-season-roof-gutter-cleaning-process.jpg?s=612x612&w=0&k=20&c=tIwE-8XK4Vl4lIGRA1xxRg578Nt8GfXU6iYNMeQi3M4=')`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="hero-overlay"></div>
        <div className="container">
          <div className="header-content slide-in-up">
            <h1>Gutter Cleaning</h1>
            <p className="header-subtitle">
              Professional gutter cleaning services that protect your home from water damage. Complete debris removal, downspout clearing, and system inspection.
            </p>
          </div>
        </div>
      </section>

      {/* Service Overview */}
<section className="service-overview">
  <div className="container">
    <div className="overview-grid">
      <div className="overview-content slide-in-left">
        <h2>Why Choose Our Gutter Cleaning Service?</h2>
        <p>
          Blocked gutters are more than just an eyesore – they're a serious threat to 
          your property. When gutters overflow, water can damage your roof, walls, 
          foundations, and landscaping. Regular professional cleaning prevents costly 
          repairs and protects your home's structural integrity.
        </p>
        <p>
          Our professional gutter cleaning service safely removes leaves, moss, twigs, 
          and debris that accumulate throughout the year. Using specialized equipment 
          and working from the ground where possible, we ensure your gutters and 
          downpipes flow freely, protecting your property from water damage all year round.
        </p>
        <div className="key-benefits">
          <div className="benefit-item">
            <span className="benefit-icon">✓</span>
            <span>Prevents water damage and damp</span>
          </div>
          <div className="benefit-item">
            <span className="benefit-icon">✓</span>
            <span>Full inspection included</span>
          </div>
          <div className="benefit-item">
            <span className="benefit-icon">✓</span>
            <span>Minor repairs identified</span>
          </div>
          <div className="benefit-item">
            <span className="benefit-icon">✓</span>
            <span>Safe, professional equipment</span>
          </div>
        </div>
      </div>
      <div className="overview-image slide-in-right">
        <img src={GutterImg} alt="Professional gutter cleaning service" />
      </div>
    </div>
  </div>
</section>

      {/* What's Included */}
      <section className="whats-included">
        <div className="container">
          <h2 className="section-title slide-in-up">What's Included in Our Gutter Cleaning Service</h2>
          
          <div className="services-grid">
            <div className="service-card slide-in-up">
              <div className="service-icon">
                <span>🍂</span>
              </div>
              <h3>Complete Debris Removal</h3>
              <p>
                Thorough removal of leaves, twigs, dirt, and other debris that can clog your gutter system and cause overflow.
              </p>
            </div>

            <div className="service-card slide-in-up">
              <div className="service-icon">
                <span>💧</span>
              </div>
              <h3>Downspout Clearing</h3>
              <p>
                Professional clearing of blocked downspouts using specialized tools to ensure proper water flow away from your foundation.
              </p>
            </div>

            <div className="service-card slide-in-up">
              <div className="service-icon">
                <span>🔍</span>
              </div>
              <h3>System Inspection</h3>
              <p>
                Comprehensive inspection for damage, proper slope, secure mounting, and identification of potential issues.
              </p>
            </div>

            <div className="service-card slide-in-up">
              <div className="service-icon">
                <span>🛡️</span>
              </div>
              <h3>Preventive Maintenance</h3>
              <p>
                Minor repairs and adjustments to prevent costly water damage and extend your gutter system's lifespan.
              </p>
            </div>

            <div className="service-card slide-in-up">
              <div className="service-icon">
                <span>♻️</span>
              </div>
              <h3>Eco-Safe Products</h3>
              <p>
                All our cleaning products are environmentally friendly and safe for your family, 
                pets, and surrounding landscaping while still being tough on dirt and stains.
              </p>
            </div>

            <div className="service-card slide-in-up">
              <div className="service-icon">
                <span>✅</span>
              </div>
              <h3>Quality Guarantee</h3>
              <p>
                We stand behind our work with a complete satisfaction guarantee. If you're not 
                happy with the results, we'll return to address any concerns at no extra cost.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Process */}
      <section className="our-process">
        <div className="container">
          <h2 className="section-title slide-in-up">Our Simple 4-Step Process</h2>
          
          <div className="process-steps">
            <div className="process-step slide-in-left">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3>Free Quote & Assessment</h3>
                <p>
                  Contact us for a free, no-obligation quote. We'll assess your Gutter's 
                  condition and provide you with a detailed estimate of the work required.
                </p>
              </div>
            </div>

            <div className="process-step slide-in-right">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3>Preparation & Setup</h3>
                <p>
                  We'll protect your property and surrounding areas, then apply pre-treatment 
                  solutions to problem areas and set up our professional cleaning equipment.
                </p>
              </div>
            </div>

            <div className="process-step slide-in-left">
              <div className="step-number">3</div>
              <div className="step-content">
                <h3>Professional Cleaning</h3>
                <p>
                  Using the correct pressure settings for your driveway material, we systematically 
                  clean every area, paying special attention to stained and heavily soiled sections.
                </p>
              </div>
            </div>

            <div className="process-step slide-in-right">
              <div className="step-number">4</div>
              <div className="step-content">
                <h3>Final Inspection</h3>
                <p>
                  We conduct a thorough quality check to ensure all areas have been properly cleaned, 
                  and discuss optional protective treatments to maintain your Gutter's appearance.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content slide-in-up">
            <h2>Ready to Restore Your Patio?</h2>
            <p>
              Get your free quote today and see how we can transform your Gutter's appearance. 
              Most quotes provided within 24 hours with no obligation to proceed.
            </p>
            <div className="cta-buttons">
              <a href="/#contact" className="btn btn-primary">Get Free Quote</a>
            </div>
            <div className="cta-assurance">
              <span>✓ Fully insured</span>
              <span>✓ Satisfaction guaranteed</span>
              <span>✓ Free quotes</span>
              <span>✓ No hidden fees</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default GutterCleaningPage;